import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import CommercePageContent
  from 'components/dashboard/commerce-content/CommercePageContent';

const DashboardCommercePage = () => (
  <LinksPageLayout activeLinksPage="commerce">
    <CommercePageContent />
  </LinksPageLayout>
);

export default DashboardCommercePage;
